<template>
	<div class="omapi-section omapi-section__getting-started" id="omapi-section__getting-started">
		<common-welcomebox title="Creating Your First Campaign">
			Click on the button below to create a new OptinMonster campaign, or watch the video to learn more about the power of OptinMonster.
		</common-welcomebox>
		<about-pro-upsell v-if="showProUpsells"/>
		<about-getting-started-overview/>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default  {
	computed : {
		...mapGetters([ 'showProUpsells' ]),
	},
}
</script>
